import { render, staticRenderFns } from "./InstrumentsPopup.vue?vue&type=template&id=3db2eb15"
import script from "./InstrumentsPopup.vue?vue&type=script&lang=js"
export * from "./InstrumentsPopup.vue?vue&type=script&lang=js"
import style0 from "./InstrumentsPopup.vue?vue&type=style&index=0&id=3db2eb15&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports